import React from "react";
import { MainLayout } from "../components/layout/mainLayout";
import SubscriptionComponent from "../components/subscription/";

const Subscription = (props) => {
  return (
    <MainLayout>
      <SubscriptionComponent />
    </MainLayout>
  );
};

export default Subscription;
